






































import { GPageBase } from '@/mixins';
import { mixins } from 'vue-class-component';
import { Component, Watch } from 'vue-property-decorator';
import { BreadCrumbElement } from '@/models/bread-crumb-element';
import { statisticsModule } from '@/store/modules/frames/statistics.module';
import { surveyAnalyzeModule } from '@/store/modules/frames/survey-analyze.module';
import GCustomBreadCrumb from '@/components/GCustomBreadCrumb.vue';
import GTitleBar from '@/components/GTitleBar.vue';
import GTemplateTopicForm from '@/components/GTopicForm.vue';
import { schoolClassModule } from '@/store/modules/entities/school-class.module';
import GSurveyAnalyzeFilter from '@/views/GSurveyAnalyze/GSurveyAnalyzeFilter.vue';
import GSurveyAnswerAggregate from '@/views/GSurveyAnalyze/GSurveyAnswerAggregate.vue';
import { SchoolClass } from '@/models/school-class/school-class';
import { masterModule } from '@/store/modules/entities/master.module';
import { Competency } from '@/models/competency/competency';
import { EChartService } from '@/service/echart/echart.service';
import GStatisticsChart from '@/views/GStatistics/GStatisticsChart.vue';
import { SurveyAnalysisMapEchartService } from '@/service/echart/survey-analysis-map.echart.service';
import { GEnum } from '@/constants/enum.defination';
import { evalSettingModule } from '@/store/modules/entities/eval-setting.module';
import GLoading from '@/components/GLoading.vue';
import { SchoolGroupTrendAnalysis } from '@/models/school-group/school-group-trend-analysis';
import { Activity } from '@/models/activity/activity';
import GSurveySelectActivityAnalyze from './GSurveySelectActivityAnalyze.vue';
import { SurveyAnalysisCircleEchartService } from '@/service/echart/survey-analysis-circle-echart-service';
import { MetaAwarenessGrowthQuestion } from '@/models/jgrow/survey-answer';
import GSurveyMetaPositiveActivity from './GSurveyMetaPositiveActivity.vue';
import GSurveyMetaExpectedAggresive from './GSurveyMetaExpectedAggressive.vue';
import { eventGiftCourseModule } from '@/store/modules/frames/event-gift-course.module';
import GSurveyAnalyzeCompetency from './GSurveyAnalyzeCompetency.vue';
import GSurveyAnalyzeCompetencyChart from './GSurveyAnalyzeCompetencyChart.vue';
import { CompetencyBoxplotEchartService } from '@/service/echart/competency-boxplot.echart.service';

@Component({
  name: 'GSurveyAnalyze',
  components: {
    GLoading,
    GSurveyAnalyzeFilter,
    GTemplateTopicForm,
    GTitleBar,
    GCustomBreadCrumb,
    GStatisticsChart,
    GSurveyAnswerAggregate,
    GSurveyMetaPositiveActivity,
    GSurveyMetaExpectedAggresive,
    GSurveyAnalyzeCompetency,
    GSurveyAnalyzeCompetencyChart,
  },
  computed: {},
  methods: {},
})
export default class GSurveyAnalyze extends mixins(GPageBase) {
  breadCrumbItems: BreadCrumbElement[] = [];
  lazy: boolean = false;
  growthMindsetMapDescriptionsColumn: object[] = [];
  eventID = 0;

  created() {
    this.eventID = this.$route.query['eventID'] ? Number(this.$route.query['eventID']) : 0;
  }

  async mounted() {
    statisticsModule.clean();
    surveyAnalyzeModule.clean();
    surveyAnalyzeModule.setEventID(this.eventID);
    await evalSettingModule.fetchAllEvalSettings();

    if (this.eventID) {
      await surveyAnalyzeModule.getEventInfo();
    }

    await surveyAnalyzeModule.fetchSurveyAnswers();

    eventGiftCourseModule.clean();
    masterModule.fetchCompetency().then((competencies: Competency[]) => {
      eventGiftCourseModule.setCompetencies(competencies);
      eventGiftCourseModule.setEventCompetencies(surveyAnalyzeModule.event.competencies);
      eventGiftCourseModule.setEChartService(new CompetencyBoxplotEchartService(competencies));
      eventGiftCourseModule.setSurveyAnswers(surveyAnalyzeModule.answers);
    });

    this.refreshChart();

    // データ読み込み終了
    statisticsModule.setLoading(false);
    this.lazy = true;
  }

  get loading(): boolean {
    return statisticsModule.loading;
  }

  get chartTypeAnswerBarGraph(): GEnum.SurveyAnalysisChartType.AnswerBarGraph {
    return GEnum.SurveyAnalysisChartType.AnswerBarGraph;
  }

  get chartTypeMetaAwarenessGrowth(): GEnum.SurveyAnalysisChartType.MetaAwarenessGrowth {
    return GEnum.SurveyAnalysisChartType.MetaAwarenessGrowth;
  }

  get chartTypeCompetencyBoGrowth(): GEnum.SurveyAnalysisChartType.CompetencyBoGrowth {
    return GEnum.SurveyAnalysisChartType.CompetencyBoGrowth;
  }

  get selectedSurveyAnalysisChartType(): GEnum.SurveyAnalysisChartType {
    return statisticsModule.selectedSurveyAnalysisChartType;
  }

  get isDisplayTrend(): boolean {
    // 追加サービスプランに傾向チェックが含まれている場合、表示する
    return this.$store.state.account.additionalPlanTypes.includes(GEnum.AdditionalPlanType.TrendCheckAcademic);
  }

  get activities(): Activity[] {
    return surveyAnalyzeModule.activities;
  }

  get competencies(): Competency[] {
    return surveyAnalyzeModule.competencies;
  }

  handleChangeChartType(chartType: GEnum.SurveyAnalysisChartType) {
    if (this.selectedSurveyAnalysisChartType === chartType) {
      // 現在選択中のタブをクリックした場合は何もしない
      return;
    }
    statisticsModule.setSelectedSurveyAnalysisChartType(chartType);
    this.refreshChart();
  }

  plusGrowthAnalyzeDataset() {
    // @ts-ignore
    this.$refs.analyzeCompetency.setDataList();
  }

  // チャート更新
  async refreshChart() {
    // 選択されたタブが「コンピテンシー成長」だったら
    if (this.selectedSurveyAnalysisChartType === this.chartTypeCompetencyBoGrowth) {
      // 初期化
      eventGiftCourseModule.setEChartService(new CompetencyBoxplotEchartService(masterModule.competencies));
      // コンピテンシー画面の描画
      if (eventGiftCourseModule.beforeExamCompetencyBoxplots.length > 0 && eventGiftCourseModule.afterExamCompetencyBoxplots.length > 0) {
        eventGiftCourseModule.echartService.addLabel(1);
        eventGiftCourseModule.echartService.addSeries(eventGiftCourseModule.beforeExamCompetencyBoxplots);
        eventGiftCourseModule.echartService.addLabel(2);
        eventGiftCourseModule.echartService.addSeries(eventGiftCourseModule.afterExamCompetencyBoxplots);
      }
    } else {
      const newChartService: EChartService = new SurveyAnalysisMapEchartService(this.activities);
      statisticsModule.setEChartService(newChartService);
      statisticsModule.echartService.addSeries(null);
      statisticsModule.setSurveyAnalysisCircleEchartService(new SurveyAnalysisCircleEchartService());
    }
  }
}
